/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Decision request body. The acting staff user's id is injected server-side
 * from the authenticated session; clients send only the reason.
 * @export
 * @interface PamVerificationDecisionBody
 */
export interface PamVerificationDecisionBody {
    /**
     * 
     * @type {string}
     * @memberof PamVerificationDecisionBody
     */
    reason: string;
}

/**
 * Check if a given object implements the PamVerificationDecisionBody interface.
 */
export function instanceOfPamVerificationDecisionBody(value: object): value is PamVerificationDecisionBody {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function PamVerificationDecisionBodyFromJSON(json: any): PamVerificationDecisionBody {
    return PamVerificationDecisionBodyFromJSONTyped(json, false);
}

export function PamVerificationDecisionBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamVerificationDecisionBody {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
    };
}

export function PamVerificationDecisionBodyToJSON(value?: PamVerificationDecisionBody | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
    };
}

